import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import Header from "../Common_Files/Header";
import Footer from "../Common_Files/Footer";
import config from "../Common_Files/Config";
import ViewProduct from "../Master/ViewProduct";
import SupplierSearch from "../Purchase/SupplierSearch";
import ProductBatch from "./ProductBatch";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";
import { format } from "date-fns";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { useNavigate } from "react-router-dom";
import ProductList from "./ProductListPurchaseModel";
import CustomDateInput from '../CommonComp/CustomDateInput';
import FormText from '../CommonComp/FormText';

//fetchSupplierData
import {
  fetchProductData,
  fetchSupplierData,
  fetchWarehouseDeliveryData,
  fetchCustomerDeliveryData,
  changeWarehouseAddress,
  changeCustomerAddress,
  calculateValue,
  acceptNumber,
  acceptDecimalNumber,
  getAddressById,
  edithandleChange1,
} from "../../services/NewPurchaseOrderService";

const EditNewPurchaseOrder = () => {
  const [supplierData, setSupplierData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [product, setProduct] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [discTableRows, setDiscTableRows] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [warehouseDeliveryAddress, setWarehouseDeliveryAddress] = useState([]);
  const [customerDeliveryAddress, setCustomerDeliveryAddress] = useState([]);
  const [deliveryAddress, setDeliveryAddress] = useState([]);
  const [customerAddress, setCustomerAddress] = useState([]);
  const [productBatch, setProductBatch] = useState([]);
  const [stdGoods, setStdGoods] = useState(0);
  const [vatAmt, setVatAmt] = useState(0);
  const [zeroGoods, setZeroGoods] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [netStdGoods, setNetStdGoods] = useState(0);
  const [netVatAmt, setNetVatAmt] = useState(0);
  const [netZeroGoods, setNetZeroGoods] = useState(0);
  const [netGrandTotal, setNetGrandTotal] = useState(0);
  const [productId, setProductId] = useState(0);
  const navigateToGRNList = useNavigate();
  const discModal = useRef(null);
  const [onso, setonso] = useState([]);
  const [soMappingCurrentPage, setSoMappingCurrentPage] = useState(1);
  const [soMappingItemsPerPage] = useState(5);
  const [soMappingTotal, setSoMappingTotal] = useState(0);
  const [soMappingTotalPages, setSoMappingTotalPages] = useState(0);
  const [soMappingLoading, setSoMappingLoading] = useState(false);
  const [currentProductIdForSO, setCurrentProductIdForSO] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [productInputValue, setProductInputValue] = useState("");
  const [picker, setSelectedProduct] = useState("");
  const { id } = useParams();
  const [grnItems, setItems] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [purchaseData, setPurchaseData] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const [preSupplierData, setPreSupplierData] = useState();
  const [preDeliverData, setPreDeliverData] = useState();
  const [precustomerDeliverData, setPrecustomerDeliverData] = useState();
  const [collectionAddress, setCollectionAddress] = useState();
  const [originalCollectionAddress, setOriginalCollectionAddress] = useState();
  const accessToken = localStorage.getItem("accessToken");
  const productBatchRef = useRef(null);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [isDelivery, setIsDelivery] = useState("delivery");
  const [modalData, setModalData] = useState(null);
  const productListRef = useRef(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [jobRefError, setJobRefError] = useState('');
  const [notesError, setNotesError] = useState('');
  const [addressErrors, setAddressErrors] = useState({});
  const [selectedProductId, setSelectedProductId] = useState(null);

  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const modalRef = useRef();

  const handleOpenPastPurchaseModal = (data) => {
    setModalData(data);
    if (productBatchRef.current) {
      productBatchRef.current();
    }
  };

  const handleDeliveryandCollectionAddress = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === "collection") {
      // When switching to collection, clear delivery addresses but restore collection address
      setDeliveryAddress({
        name: "",
        code: "",
        address_line1: "",
        address_line2: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
      });
      setCustomerAddress({
        name: "",
        code: "",
        address_line1: "",
        address_line2: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
      });
      // Restore original collection address if it exists
      if (originalCollectionAddress) {
        setCollectionAddress(originalCollectionAddress);
      }
    } else if (selectedValue === "delivery") {
      // When switching to delivery, clear collection address but preserve delivery addresses
      setCollectionAddress({
        name: "",
        code: "",
        address_line1: "",
        address_line2: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
      });
      // Don't clear deliveryAddress and customerAddress - preserve them
    }

    setIsDelivery(selectedValue);
  };

  const handleWarehouseandCustomerAddress = (event) => {
    setIsDelivery(event.target.value);
    setDeliveryAddress([]);
    setCustomerAddress([]);
  };

  useEffect(() => {
    $("#dsTable tbody").off("click", ".applybtn");
    $("#dsTable tbody").on("click", ".applybtn", function () {
      $("#freestock").empty();
      $("#stock").empty();
      $("#on_so").empty();
      $("#allocation").empty();
      $("#onpf").empty();
      $("#onpo").empty();
      const product_id = $(this).data("id");
      const formData = new FormData();
      formData.append("id", product_id);
      document.getElementById("viewProductForm").reset();
      const fetchProductData = async () => {
        const apiUrl = `${config.api_url}/ws-get-products-by-id`;
        try {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            body: formData,
          });

          const data = await response.json();
          $("#code").val(data.products[0].code);
          $("#packValue").val(data.products[0].pack);
          $("#vat").val(data.products[0].vat);
          $("#weight").val(data.products[0].gross_weight);
          $("#supplier").val(data.products[0].supplier_name);
          $("#description").val(data.products[0].product_desc);
          $("#sizeValue").val(data.products[0].size);
          $("#barcode").val(data.products[0].unit_barcode);
          $("#view_case_barcode").val(data.products[0].case_barcode);
          $("#pallet_qty").val(data.products[0].pallet_qty);
          $("#case_price").val(data.products[0].cost);
          $("#view_sell_price").val(data.products[0].price);
          $("#product_status").html(
            data.products[0].status !== 0
              ? 'Status : <span style="margin-left: 5px;" class="badge bg-success">Active</span>'
              : 'Status : <span style="margin-left: 5px;" class="badge bg-secondary"> Inactive</span>'
          );
          $("#viewcbm").val(data.products[0].cbm);
          $("#brandname").val(data.products[0].brand);
          $("#categooryName").val(data.products[0].category);
          $("#editnetWeight").val(data.products[0].net_weight);
          $("#editgrossWeight").val(data.products[0].gross_weight);
          $("#freestock").append(data.freestock === null ? 0 : data.freestock + parseInt(data.products[0].quantity));
          $("#stock").append(parseInt(data.products[0].quantity));
          $("#on_so").append(data.onso === null ? 0 : data.onso);
          $("#allocation").append(
            data.allocation === null ? 0 : data.allocation
          );
          $("#onpf").append(data.pf === null ? 0 : data.pf);
          $("#onpo").append(data.on_purchase === null ? 0 : data.on_purchase);
        } catch (error) {
          console.error("Error fetching product data:", error);
        }
      };
      fetchProductData();
    });

    return () => {
      $("#dsTable tbody").off("click", ".applybtn");
    };
  }, []);

  const fetchGRNProducts = async (id) => {
    if (!id) {
      setLoadError('Invalid purchase order id.');
      setPageLoading(false);
      return;
    }
    setPageLoading(true);
    setLoadError('');
    $("#purchase_id").val(id);
    const apiUrl = `${config.api_url}/ws-purchase-item-by-id`;
    let formData = new FormData();
    formData.append("purchase_id", id);

    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.data?.success || !response.data?.purchase) {
        setLoadError(response.data?.message || 'Purchase order not found.');
        setItems([]);
        setPurchaseData(null);
        setPageLoading(false);
        return;
      }

      const purchase_item = Array.isArray(response.data.purchase_item)
        ? response.data.purchase_item
        : [];
      const initializedGRNItems = purchase_item.map((item) => ({
        ...item,
        // bedsLeds,
        // costToServe,
        // offInvoice,
        // retro,
        // sugroRetro,
        // promptPayment,
        // desc,
      }));

      setItems(initializedGRNItems);
      setBatchData(Array.isArray(response.data.batch_info) ? response.data.batch_info : []);
      const purchase = response.data.purchase;
      setPurchaseData(purchase);
      setPreSupplierData(purchase.supplier_id ?? '');
      // setPreDeliverData(response.data.purchase.delivery_id);
      // setPrecustomerDeliverData(response.data.purchase.delivery_id);

      if (purchase.delivery_type === "collection") {
        setPreDeliverData("");
        setPrecustomerDeliverData("");
        setIsDelivery("collection");
        const collectionData = {
          address_line1: purchase?.address_line1 || "",
          address_line2: purchase?.address_line2 || "",
          city: purchase?.city || "",
          state: purchase?.state || "",
          country: purchase?.country || "",
          postcode: purchase?.postcode || "",
        };
        setCollectionAddress(collectionData);
        setOriginalCollectionAddress(collectionData); // Store original data
      }

      if (
        purchase.is_wharehouse_or_customer === "warehouse" &&
        purchase.delivery_type === "delivery"
      ) {
        setPreDeliverData(response.data.purchase.delivery_id);
        setPrecustomerDeliverData();

        // Populate React state so inputs are editable and show values
        setDeliveryAddress({
          name: purchase?.name || "",
          code: purchase?.code || "",
          address_line1: purchase?.address_line1 || "",
          address_line2: purchase?.address_line2 || "",
          city: purchase?.city || "",
          state: purchase?.state || "",
          country: purchase?.country || "",
          postcode: purchase?.postcode || "",
        });
        setIsDelivery(purchase.is_wharehouse_or_customer);
      }

      if (
        purchase.is_wharehouse_or_customer === "customer" &&
        purchase.delivery_type === "delivery"
      ) {
        $("#caddr1").val(purchase?.address_line1);
        $("#caddr2").val(purchase?.address_line2);
        $("#ccity").val(purchase?.city);
        $("#cstate").val(purchase?.state);
        $("#ccountry").val(purchase?.country);
        $("#cpostcode").val(purchase?.postcode);
        // $('#warehouse_id').val(purchase.warehouse_id); // This line is commented out as per your original code

        setCustomerAddress({
          address_line1: purchase?.address_line1,
          address_line2: purchase?.address_line2,
          city: purchase?.city,
          state: purchase?.state,
          country: purchase?.country,
          postcode: purchase?.postcode,
        });
        setPreDeliverData("");
        setPrecustomerDeliverData(response.data.purchase.delivery_id);
        setIsDelivery(purchase.is_wharehouse_or_customer);
      }

      $("#arrival_date").val(purchase?.arrival_date);
      $("#job_ref").val(purchase?.job_ref);
      $("#notes").val(purchase?.notes);
    } catch (error) {
      setLoadError('An error occurred while loading the purchase order.');
      setItems([]);
      setPurchaseData(null);
    } finally {
      setPageLoading(false);
    }
  };

  const checkJobRefExists = async (jobRef, excludePurchaseId = null) => {
    if (!jobRef || jobRef.trim() === '') {
      return null;
    }

    try {
      const checkFormData = new FormData();
      checkFormData.append('job_ref', jobRef.trim());
      if (excludePurchaseId) {
        checkFormData.append('exclude_purchase_id', excludePurchaseId);
      }

      const response = await axios.post(
        `${config.api_url}/ws-check-job-ref-exists`,
        checkFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data && response.data.exists) {
        return {
          exists: true,
          poNumber: response.data.po_number || response.data.reference_no || ''
        };
      }
      return { exists: false };
    } catch (error) {
      console.error("Error checking job reference:", error);
      return null;
    }
  };

  const calculateValue = (quantity, price) => {
    return quantity && price ? quantity * price : 0;
  };

  const handleInputChange = (e, product_id, field, setItems, grnItems, order_qty) => {
    // Allow empty string for clearing the input
    const inputValue = e.target.value;
    let finalValue;

    if (inputValue === "") {
      finalValue = "";
    } else {
      finalValue = acceptNumber(inputValue);
    }

    // Convert to number for calculations, use 0 if empty or invalid
    const value1 = finalValue === "" ? 0 : parseFloat(finalValue) || 0;

    const initializedItems = grnItems.map((item) => {
      if (item.product_id !== product_id) {
        return item;
      }

      return {
        ...item,
        received_qty: value1,
        order_qty: value1,
        order_qty_display: finalValue, // Store the display value
        value:
          field === "quantity"
            ? calculateValue(value1, item.cost)
            : calculateValue(item.quantity, value1),
        netp: parseFloat(item.cost || 0) - parseFloat(item.desc || 0),
        netprice:
          field === "quantity"
            ? calculateValue(value1, item.cost)
            : calculateValue(item.quantity, value1),
        free_stock:
          (Number(item.sys_quantity) || 0) +
          (Number(item.free_stock) || 0) +
          Number(value1) -
          item.order_qty,
      };
    });

    setItems(initializedItems);
  };

  const handleInputChange_cprice = (e, product_id, field, setItems, grnItems, newlyAdded, order_qty) => {
    // Allow empty string for clearing the input
    const inputValue = e.target.value;
    let finalValue;

    if (inputValue === "") {
      finalValue = "";
    } else {
      finalValue = acceptDecimalNumber(inputValue);
    }

    // Convert to number for calculations, use 0 if empty or invalid
    const value1 = finalValue === "" ? 0 : parseFloat(finalValue) || 0;

    if (!newlyAdded) {
      const initializedItems = grnItems.map((item) => {
        if (item.product_id !== product_id) {
          return item;
        }

        return {
          ...item,
          received_qty: order_qty,
          order_qty: order_qty,
          cost: value1,
          cost_display: finalValue, // Store the display value
          value:
            field === "quantity"
              ? calculateValue(order_qty, value1)
              : calculateValue(order_qty, value1),

          netp: value1 - parseFloat(item.desc || 0),
          netprice:
            (field === "quantity"
              ? calculateValue(order_qty, value1)
              : calculateValue(order_qty, value1)) -
            (parseFloat(item.retro || 0) +
              parseFloat(item.promptPayment || 0) +
              parseFloat(item.costToServe || 0) +
              parseFloat(item.offInvoice || 0) +
              parseFloat(item.bedsLeds || 0) +
              parseFloat(item.sugroRetro || 0)),
          fstk:
            (Number(item.sys_quantity) || 0) +
            (Number(item.free_stock) || 0) +
            value1,
        };
      });

      setItems(initializedItems);
    }
  };

  const handleSubmit = async (e, grnItems, productId) => {
    e.preventDefault();
    const retro = parseFloat(formData.retro) || 0;
    const prompt_payment = parseFloat(formData.promptPayment) || 0;
    const cost_to_serve = parseFloat(formData.costToServe) || 0;
    const off_invoice = parseFloat(formData.offInvoice) || 0;
    const sugroRetro = parseFloat(formData.sugroRetro) || 0;
    const bedsLeds = parseFloat(formData.bedsLeds) || 0;
    let total =
      retro +
      prompt_payment +
      cost_to_serve +
      off_invoice +
      sugroRetro +
      bedsLeds;
    let a = 0;
    const initializedItems = grnItems.map((item) => {
      if (item.id !== productId || item.cost <= total) {
        return item;
      }

      a = 1;
      return {
        ...item,
        netp:
          item.cost -
          retro -
          prompt_payment -
          cost_to_serve -
          off_invoice -
          bedsLeds -
          sugroRetro,
        netprice:
          item.cost * item.order_qty -
          retro -
          prompt_payment -
          cost_to_serve -
          off_invoice -
          bedsLeds -
          sugroRetro,
        retro,
        promptPayment: prompt_payment,
        costToServe: cost_to_serve,
        offInvoice: off_invoice,
        bedsLeds,
        sugroRetro,
        desc: total,
      };
    });

    if (a === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please enter a discount less than the value.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    } else {
      setItems(initializedItems);
    }

    // console.log('Initialized Items:', grnItems);

    // Reset form data
    setFormData({
      retro: "",
      promptPayment: "",
      costToServe: "",
      offInvoice: "",
      bedsLeds: "",
      sugroRetro: "",
    });

    const bsModal = window.bootstrap.Modal.getInstance(discModal.current);
    if (bsModal) bsModal.hide();
  };

  const [formData, setFormData] = useState({
    retro: "",
    promptPayment: "",
    costToServe: "",
    offInvoice: "",
    bedsLeds: "",
    sugroRetro: "",
  });

  const handleDiscount = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleShowPastPurchaseModal = (showModalHandler) => {
    showModalHandler();
  };

  useEffect(() => {
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }
    fetchSupplierData(setSupplierData);
    fetchProductData(setProductData);
    fetchWarehouseDeliveryData(setWarehouseDeliveryAddress);
    fetchCustomerDeliveryData(setCustomerDeliveryAddress);
    fetchGRNProducts(id);
  }, [id]);

  const orderTotals = useMemo(() => {
    const totalVat = grnItems.reduce((sum, item) => {
      const itemVat =
        parseFloat(item.order_qty) *
        parseFloat(item.cost) *
        (parseFloat(item.vat_percentage) / 100) || 0;
      return sum + itemVat;
    }, 0);

    const goodsTotal = grnItems.reduce(
      (total, row) =>
        total + parseFloat(row.order_qty) * parseFloat(row.cost) || 0,
      0
    );

    const stdGoodsTotal = grnItems.reduce((total, row) => {
      if (parseFloat(row.vat) > 0) {
        return total + parseFloat(row.order_qty) * parseFloat(row.cost) || 0;
      }
      return total;
    }, 0);

    const zeroGoodsTotal = grnItems.reduce((total, row) => {
      const vat = parseFloat(row.vat);
      const value = parseFloat(row.value);
      if (!isNaN(value) && vat === 0) {
        return total + value;
      }
      return total;
    }, 0);

    const totalNetVat = grnItems.reduce((sum, item) => {
      const itemVat =
        (parseFloat(item.cost) - parseFloat(item.desc)) *
        parseFloat(item.order_qty) *
        (parseFloat(item.vat_percentage) / 100) || 0;
      return sum + itemVat;
    }, 0);

    const newNetGrandTotal = grnItems.reduce(
      (total, row) =>
        total + (parseFloat(row.cost) - parseFloat(row.desc)) * parseFloat(row.order_qty) || 0,
      0
    );

    const netStdGoodsTotal = grnItems.reduce((total, row) => {
      const cost = parseFloat(row.cost) || 0;
      const desc = parseFloat(row.desc) || 0;
      const orderQty = parseFloat(row.order_qty) || 0;
      const vat = parseFloat(row.vat) || 0;
      if (vat > 0) {
        return total + (cost - desc) * orderQty;
      }
      return total;
    }, 0);

    const netZeroGoodsTotal = grnItems.reduce((total, row) => {
      const vat = parseFloat(row.vat);
      const cost = parseFloat(row.cost) || 0;
      const desc = parseFloat(row.desc) || 0;
      const order_qty = parseInt(row.order_qty, 10) || 0;
      if (!isNaN(vat) && vat === 0) {
        return total + (cost - desc) * order_qty;
      }
      return total;
    }, 0);

    return {
      vatAmt: totalVat,
      grandTotal: goodsTotal + totalVat,
      stdGoods: stdGoodsTotal,
      zeroGoods: zeroGoodsTotal,
      netVatAmt: totalNetVat,
      netGrandTotal: newNetGrandTotal + totalNetVat,
      netStdGoods: netStdGoodsTotal,
      netZeroGoods: netZeroGoodsTotal,
    };
  }, [grnItems]);

  useEffect(() => {
    setVatAmt(orderTotals.vatAmt);
    setGrandTotal(orderTotals.grandTotal);
    setStdGoods(orderTotals.stdGoods);
    setZeroGoods(orderTotals.zeroGoods);
    setNetVatAmt(orderTotals.netVatAmt);
    setNetGrandTotal(orderTotals.netGrandTotal);
    setNetStdGoods(orderTotals.netStdGoods);
    setNetZeroGoods(orderTotals.netZeroGoods);
  }, [orderTotals]);

  const handleProductChange = (inputValue) => {
    setSelectedProduct(inputValue);
  };

  const handleChange = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      setProductInputValue(selectedOption);
      edithandleChange1(selectedOption.value, grnItems, setItems);
    } else {
      setProductInputValue(null);
      console.warn("Selected option is invalid or missing a value");
    }
  };

  const getProductBatchData = async (id) => {
    try {
      const formData = new FormData();
      formData.set("product_id", id);

      const response = await axios.post(
        `${config.api_url}/ws-batch-info-by-product-id`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const data = response.data;
      setProductBatch(data.batch);
      handleOpenPastPurchaseModal(data.batch);
    } catch (error) {
      console.error("Error fetching product batch data:", error);
    }
  };

  const removeRow = (id, setItems) => {
    setItems((prevRows) => prevRows.filter((row) => row.id !== id));
  };

  const getonpo = async (id, page = 1) => {
    try {
      setSoMappingLoading(true);
      setCurrentProductIdForSO(id);
      const formData = new FormData();
      formData.set("product_id", id);
      formData.set("page", page);
      formData.set("limit", soMappingItemsPerPage);
      
      const response = await axios.post(
        `${config.api_url}/ws-customer-wise-sales-order`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const data = response.data;
      setonso(data.sales || []);
      
      // Update pagination metadata
      if (data.pagination) {
        setSoMappingCurrentPage(data.pagination.current_page || 1);
        setSoMappingTotal(data.pagination.total || 0);
        setSoMappingTotalPages(data.pagination.total_pages || 0);
      } else {
        // Fallback for non-paginated API response
        setSoMappingCurrentPage(1);
        setSoMappingTotal(data.sales?.length || 0);
        setSoMappingTotalPages(Math.ceil((data.sales?.length || 0) / soMappingItemsPerPage));
      }
    } catch (error) {
      console.error("Error fetching product batch data:", error);
      setonso([]);
      setSoMappingTotal(0);
      setSoMappingTotalPages(0);
    } finally {
      setSoMappingLoading(false);
    }
  };

  // Function to handle page change
  const handleSoMappingPageChange = (newPage) => {
    if (currentProductIdForSO && newPage >= 1) {
      getonpo(currentProductIdForSO, newPage);
    }
  };

  const submitPurchaseOrderForm = async () => {
    const form = document.getElementById("newPurchaseForm");
    const formData = new FormData(form);
    formData.append("purchase_id", id);
    const supplierId = formData.get("supplier_id");
    const job_ref = formData.get("job_ref");

    // if (job_ref) {
    // } else {
    //   Swal.fire({
    //     title: "Error!",
    //     text: "Job Ref is Required",
    //     icon: "error",
    //     timer: 1500,
    //     showConfirmButton: false,
    //   });
    //   return;
    // }

    if (supplierId) {
    } else {
      Swal.fire({
        title: "Error!",
        text: "Supplier is Required",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }
    const hasValidProduct = grnItems.some((row) => {
      const quantity = parseFloat(row.order_qty);
      return !isNaN(quantity) && quantity > 0;
    });

    if (!grnItems.length || !hasValidProduct) {
      Swal.fire({
        title: "Error!",
        text: "Please select at least one product and ensure the quantity is greater than zero.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }
    console.log(grnItems);
    // return;
    grnItems.forEach((row, index) => {
      formData.append(`code[${index}]`, row.code);
      formData.append(`product_id[${index}]`, row.product_id);
      formData.append(`packsize[${index}]`, row.pack);
      formData.append(`productSize[${index}]`, row.size);
      formData.append(`qty[${index}]`, row.order_qty);
      formData.append(`sys_qty[${index}]`, row.sys_quantity);
      formData.append(`price[${index}]`, row.cost);
      formData.append(`value[${index}]`, row.value);
      formData.append(`Disc[${index}]`, row.desc || 0);
      formData.append(`NetP[${index}]`, row.netp || 0);
      formData.append(`vat[${index}]`, row.vat);
      formData.append(`vatpercentage[${index}]`, row.vat_percentage);
      formData.append(`currrentStock[${index}]`, row.curStock);
      formData.append(`onSO[${index}]`, row.onSO);
      formData.append(`fstk[${index}]`, row.fstk);
      formData.append(`retro[${index}]`, row.retro);
      formData.append(`promptPayment[${index}]`, row.promptPayment);
      formData.append(`costToServe[${index}]`, row.costToServe);
      formData.append(`offInvoice[${index}]`, row.offInvoice);
      formData.append(`bedsLeds[${index}]`, row.bedsLeds);
      formData.append(`sugroRetro[${index}]`, row.sugroRetro);
      formData.append(`sale_id[${index}]`, row.sale_id || ''); // <-- Add this line
    });

    try {
      const response = await axios.post(
        `${config.api_url}/ws-update-purchases-order`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const result = response.data;
      Swal.fire({
        title: "Success!",
        text: "Order submitted successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      navigateToGRNList("/GRN");
    } catch (error) {
      console.error("Error accepting order:", error);
    }
  };

  const handleDiscClick = (id) => {
    setProductId(id);
    let data = grnItems.find((item) => item.id === id);

    // console.log(data);

    if (
      data.bedsLeds ||
      data.costToServe ||
      data.offInvoice ||
      data.retro ||
      data.sugroRetro ||
      data.promptPayment
    ) {
      setFormData({
        retro: data.retro || 0,
        promptPayment: data.promptPayment || 0,
        costToServe: data.costToServe || 0,
        offInvoice: data.offInvoice || 0,
        bedsLeds: data.bedsLeds || 0,
        sugroRetro: data.sugroRetro || 0,
      });
    } else {
      setFormData({
        retro: "",
        promptPayment: "",
        costToServe: "",
        offInvoice: "",
        bedsLeds: "",
        sugroRetro: "",
      });
    }
  };

  const getProductList = async (id) => {
    try {
      const formData = new FormData();
      formData.set("product_id", id);

      const response = await axios.post(
        `${config.api_url}/ws-get-products`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const data = response.data;
      setProductBatch(data.products);
      handleOpenProductListModal(data.products);
    } catch (error) {
      console.error("Error fetching product batch data:", error);
    }
  };

  const handleOpenProductListModal = (data) => {
    setModalData(data);
    if (productListRef.current) {
      productListRef.current();
    }
  };

  const handleCheckboxChange = (event, orderId, productId, saleId) => {
    if (event.target.checked) {
      // Add orderId, productId, and saleId to the selected list as an object
      setSelectedOrderIds((prev) => {
        const newSelection = { orderId, productId, saleId };
        return [...prev, newSelection];
      });
    } else {
      // Remove orderId, productId, and saleId from the selected list
      handleSoUndo(orderId, productId, saleId);
      setSelectedOrderIds((prev) =>
        prev.filter((item) => item.orderId !== orderId || item.productId !== productId || item.saleId !== saleId)
      );
    }
  };

  const handleSoSubmit = async () => {
    // Build a map of productId to sales_item_ids and sale_ids
    const salesItemMap = {};
    const saleIdMap = {};

    selectedOrderIds.forEach(({ orderId, productId, saleId }) => {
      if (!salesItemMap[productId]) {
        salesItemMap[productId] = [];
      }
      if (!saleIdMap[productId]) {
        saleIdMap[productId] = [];
      }
      salesItemMap[productId].push(orderId);
      saleIdMap[productId].push(saleId);
    });

    // Update all grnItems that have selected sales
    const updatedGrnItems = grnItems.map((item) => {
      if (salesItemMap[item.product_id] && saleIdMap[item.product_id]) {
        return {
          ...item,
          sales_item_id: salesItemMap[item.product_id].join(','),
          sale_id: saleIdMap[item.product_id].join(','),
        };
      }
      return item;
    });

    setItems(updatedGrnItems);

    if (modalRef.current) {
      const bsModal = window.bootstrap.Modal.getInstance(modalRef.current);
      if (bsModal) bsModal.hide();
    }
  };

  const handleSoUndo = (orderId, productId, saleId) => {
    const salesItemMap = {};
    const saleIdMap = {};

    selectedOrderIds.forEach(({ orderId: id, productId: pid, saleId: sid }) => {
      if (!salesItemMap[pid]) {
        salesItemMap[pid] = [];
      }
      if (!saleIdMap[pid]) {
        saleIdMap[pid] = [];
      }
      salesItemMap[pid].push(id);
      saleIdMap[pid].push(sid);
    });
    console.log(salesItemMap);
    // Update tableRows to remove the unchecked orderId
    const updatedTableRows = tableRows.map((item) => {
      // Only update the item if its productId matches
      console.log(item);
      if (item.id === productId) {

        if (salesItemMap[productId]) {
          const updatedOrderIds = salesItemMap[productId].filter(id => id !== orderId); // Remove the unchecked orderId
          const updatedSaleIds = (saleIdMap[productId] || []).filter(id => id !== saleId);
          return {
            ...item,
            sales_item_id: updatedOrderIds.join(','), // Update sales_item_id
            sale_id: updatedSaleIds.join(','),
          };
        } else {
          // If no order IDs are present for this product, clear the sales_item_id
          return {
            ...item,
            sales_item_id: '', // Clear sales_item_id if no orders are left
            sale_id: '',
          };
        }
      }
      return item; // Return original item if conditions are not met
    });
    console.log(updatedTableRows);
    setTableRows(updatedTableRows);

  };

  return (
    <div>
      <div className="modal fade" id="ON-PO" tabIndex="-1" ref={modalRef}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto', padding: '15px' }}>
              {soMappingLoading ? (
                <div className="text-center py-3">
                  <span>Loading...</span>
                </div>
              ) : (
                <>
                  <div style={{ maxHeight: '50vh', overflowY: 'auto', marginBottom: '15px' }}>
                    {onso.map((order, index) => (
                      <div className="partialbox" key={order.id || index} style={{ marginBottom: '15px' }}>
                        <h3 style={{ fontSize: '14px', marginBottom: '10px' }}>
                          S.O: {order.reference_no}{" "}
                          <span>
                            {order.company_name} ({order.code})
                          </span>
                        </h3>
                        <table className="table table-bordered dataTable" style={{ marginBottom: 0 }}>
                          <thead>
                            <tr>
                              <th>Assign</th>
                              <th>Order Qty</th>
                              <th>On P.O</th>
                              <th>Balance</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <input
                                  type="checkbox"
                                  name={`gridRadios-${order.id}`}
                                  value={order.id}
                                  onChange={(e) => handleCheckboxChange(e, order.id, order.product_id, order.sale_id)}
                                  checked={selectedOrderIds.some(item => item.orderId === order.id)}
                                />
                              </td>
                              <td>{order.quantity}</td>
                              <td>{order.received_quantity || 0}</td>
                              <td>{(order.quantity || 0) - (order.received_quantity || 0)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ))}
                  </div>
                    
                    {/* Pagination Controls */}
                    {soMappingTotalPages > 1 && (
                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-3 pt-3 border-top" style={{ flexWrap: 'wrap', gap: '10px' }}>
                        <div className="mb-2 mb-sm-0" style={{ fontSize: '12px' }}>
                          <span className="text-muted">
                            Showing {((soMappingCurrentPage - 1) * soMappingItemsPerPage) + 1} to {Math.min(soMappingCurrentPage * soMappingItemsPerPage, soMappingTotal)} of {soMappingTotal} orders
                          </span>
                        </div>
                        <nav>
                          <ul className="pagination mb-0" style={{ flexWrap: 'wrap' }}>
                            <li className={`page-item ${soMappingCurrentPage === 1 || soMappingLoading ? 'disabled' : ''}`}>
                              <button
                                className="page-link"
                                onClick={() => handleSoMappingPageChange(soMappingCurrentPage - 1)}
                                disabled={soMappingCurrentPage === 1 || soMappingLoading}
                              >
                                Previous
                              </button>
                            </li>
                            {Array.from({ length: Math.min(soMappingTotalPages, 10) }, (_, i) => {
                              let page;
                              if (soMappingTotalPages <= 10) {
                                page = i + 1;
                              } else if (soMappingCurrentPage <= 5) {
                                page = i + 1;
                              } else if (soMappingCurrentPage >= soMappingTotalPages - 4) {
                                page = soMappingTotalPages - 9 + i;
                              } else {
                                page = soMappingCurrentPage - 5 + i;
                              }
                              return (
                                <li
                                  key={page}
                                  className={`page-item ${soMappingCurrentPage === page ? 'active' : ''} ${soMappingLoading ? 'disabled' : ''}`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => handleSoMappingPageChange(page)}
                                    disabled={soMappingLoading}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            })}
                            <li className={`page-item ${soMappingCurrentPage === soMappingTotalPages || soMappingLoading ? 'disabled' : ''}`}>
                              <button
                                className="page-link"
                                onClick={() => handleSoMappingPageChange(soMappingCurrentPage + 1)}
                                disabled={soMappingCurrentPage === soMappingTotalPages || soMappingLoading}
                              >
                                Next
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}
                  </>
                )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="popup-innerbtn-common"
                onClick={handleSoSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="adnw-prct" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&nbsp;</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="partialbox">
                <h3>Search (Code/Description/Unit Barcode)</h3>
                <table className="table table-bordered dataTable">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Description</th>
                      <th>PK</th>
                      <th>Size</th>
                      <th>Unit Barcode</th>
                      <th>Stock</th>
                      <th>F.Stk</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <a href="#" target="blank">
                          SKI010
                        </a>
                      </td>
                      <td>SKITTLES CRAZY SOURS</td>
                      <td>36</td>
                      <td>45GM</td>
                      <td>&nbsp;</td>
                      <td>324</td>
                      <td>176</td>
                    </tr>

                    <tr>
                      <td>
                        <a href="#" target="blank">
                          SKI010
                        </a>
                      </td>
                      <td>SKITTLES CRAZY SOURS</td>
                      <td>36</td>
                      <td>45GM</td>
                      <td>&nbsp;</td>
                      <td>324</td>
                      <td>176</td>
                    </tr>
                    <tr>
                      <td>
                        <a href="#" target="blank">
                          SKI010
                        </a>
                      </td>
                      <td>SKITTLES CRAZY SOURS</td>
                      <td>36</td>
                      <td>45GM</td>
                      <td>&nbsp;</td>
                      <td>324</td>
                      <td>176</td>
                    </tr>

                    <tr>
                      <td>
                        <a href="#" target="blank">
                          SKI010
                        </a>
                      </td>
                      <td>SKITTLES CRAZY SOURS</td>
                      <td>36</td>
                      <td>45GM</td>
                      <td>&nbsp;</td>
                      <td>324</td>
                      <td>176</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ProductBatch
        onViewPastPurchase={(showModal) => {
          productBatchRef.current = showModal;
        }}
        getProductBatchData={getProductBatchData}
        modalData={modalData}
      />

      <div className="modal fade" id="viw-disk" tabIndex="-1" ref={discModal}>
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">&nbsp; Add Discount</h6>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="adddiscount-popup">
                <form
                  onSubmit={(e) => handleSubmit(e, grnItems, productId)}
                  id="addDiscountForm"
                >
                  <table className="table table-bordered dataTable">
                    <tbody>
                      <tr>
                        <td>Retro</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="retro"
                            value={formData.retro}
                            onChange={handleDiscount}
                            onFocus={(e) => e.target.select()}
                            autoComplete="off"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Prompt Payment</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="promptPayment"
                            value={formData.promptPayment}
                            onChange={handleDiscount}
                            onFocus={(e) => e.target.select()}
                            autoComplete="off"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Cost to Serve</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="costToServe"
                            value={formData.costToServe}
                            onChange={handleDiscount}
                            onFocus={(e) => e.target.select()}
                            autoComplete="off"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Off Invoice</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="offInvoice"
                            value={formData.offInvoice}
                            onChange={handleDiscount}
                            onFocus={(e) => e.target.select()}
                            autoComplete="off"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Beds & Leds</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="bedsLeds"
                            value={formData.bedsLeds}
                            onChange={handleDiscount}
                            onFocus={(e) => e.target.select()}
                            autoComplete="off"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Sugro Retro</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="sugroRetro"
                            value={formData.sugroRetro}
                            onChange={handleDiscount}
                            onFocus={(e) => e.target.select()}
                            autoComplete="off"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    className="popup-innerbtn-common"
                    type="submit"
                    style={{ marginTop: "10px" }}
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Header />
      <ViewProduct product_id={selectedProductId} />

      <ProductList
        onViewPastPurchase={(showModal) => {
          productListRef.current = showModal;
        }}
        getProductBatchData={getProductBatchData}
        modalData={modalData}
        setTableRows={setItems}
        tableRows={grnItems}
      />


      <form id="newPurchaseForm">
        <div className="breadcrumbs">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg-12 col-sm-12">
                {" "}
                <a href="#">
                  <i className="fa fa-home"></i>
                </a>{" "}
                &gt; <a href="/dashboard">Dashboard</a> &gt;{" "}
                <span className="last-crumb">Edit Purchase Order</span>{" "}
              </div>
            </div>
          </div>
        </div>
        <div className="main-container">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg-12 col-sm-12">
                {pageLoading && (
                  <div className="alert alert-info">Loading purchase order...</div>
                )}
                {!pageLoading && loadError && (
                  <div className="alert alert-danger">{loadError}</div>
                )}
                <div className="dashboard">
                  <div className="">
                    <div className="dashform">
                      <div className="topsearch-area">
                        <div className="row">
                          <div className="col-12 col-lg-4 col-sm-4">
                            <div className="row">
                              <label
                                htmlFor="inputText"
                                className="col-sm-2 col-form-label"
                              >
                                Supplier
                              </label>
                              <div className="col-sm-8 col-lg-8 col-md-8">
                                <select
                                  name="supplier_id"
                                  className="form-select"
                                  value={preSupplierData}
                                  onChange={(e) => {
                                    setPreSupplierData(e.target.value);
                                  }}
                                  required
                                >
                                  <option value="">Select Supplier</option>
                                  {(Array.isArray(supplierData) ? supplierData : []).map((item, index) => (
                                    <option key={index} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-lg-3 col-sm-3">
                            <div className="row">
                              {/* <label
    htmlFor="inputText"
    className="col-sm-4 col-form-label"
    >
    Product:
                              </label> */}

                              {purchaseData?.status === "Draft" && (
                                <div className="col-sm-8">
                                  <buttion
                                    to="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      getProductList();
                                    }} className="create-catalogue-btn-left"
                                  >
                                    Add New Product
                                  </buttion>
                                </div>
                              )}
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="verical-scrl-wrapper common-table purchase-no-tbl purchase-new-order-table-scroll purchase-edit-order-scroll"
                      id="style-3"
                    >
                      <table
                        className="table table-bordered dataTable"
                        id="dsTable"
                      >
                        <thead>
                          <tr>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Pk</th>
                            <th>Size</th>
                            <th>Qty</th>
                            <th>CPrice</th>
                            <th>Value</th>
                            <th>Disc</th>
                            <th>NetP</th>
                            <th>VAT</th>
                            <th>CurStock</th>
                            <th>On S.O</th>
                            <th>FStk</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          {grnItems.length === 0 ? (
                            <tr style={{ textAlign: "center" }}>
                              <td colSpan={14}>No product added</td>
                            </tr>
                          ) : (
                            grnItems.map((row) => {
                              const net_price = parseFloat(row.cost) || 0;
                              const value = parseFloat(row.value) || 0;

                              // console.log('net_value'+value);
                              const retro = parseFloat(row.retro) || 0;
                              const promptPayment =
                                parseFloat(row.promptPayment) || 0;
                              const costToServe =
                                parseFloat(row.costToServe) || 0;
                              const offInvoice =
                                parseFloat(row.offInvoice) || 0;
                              const bedsLeds = parseFloat(row.bedsLeds) || 0;
                              const sugroRetro =
                                parseFloat(row.sugroRetro) || 0;
                              const vat = parseFloat(row.vat) || 0;
                              //    const totalCosts = promptPayment + costToServe + offInvoice + bedsLeds + sugroRetro + retro;
                              const totalCosts = parseFloat(row.desc) || 0;
                              const totalCost =
                                (parseFloat(row.cost) || 0) *
                                (parseFloat(row.order_qty) || 0); // Total cost of the items
                              const vatPercentage =
                                parseFloat(row.vat_percentage) || 0; // Ensure vat_percentage is a number
                              const vatAmount = (
                                (totalCost * vatPercentage) /
                                100
                              ).toFixed(2); // VAT amount based on total cost

                              const fstk_cal = (parseInt(row.free_stock) || 0) + (parseInt(row.sys_quantity) || 0);



                              return (
                                <tr key={row.id}>
                                  <td>
                                    <input
                                      type="hidden"
                                      name="product_id[]"
                                      value={row.product_id}
                                    />
                                    {(row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001') ? (
                                      row.code
                                    ) : (
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          getProductBatchData(row.product_id);
                                        }}
                                      >
                                        {row.code}
                                      </Link>
                                    )}
                                  </td>
                                  <td>
                                    <p className="cut-text">
                                      {(row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001') ? (
                                        row.product_desc
                                      ) : (
                                        <a
                                          data-bs-toggle="modal"
                                          className="applybtn"
                                          data-id={row.product_id}
                                          data-bs-target="#viewproduct"
                                          onClick={() => setSelectedProductId(row.id)}

                                        >
                                          {row.product_desc}
                                        </a>
                                      )}
                                    </p>
                                  </td>
                                  <td>{row.pack}</td>
                                  <td>{row.size}</td>
                                  <td>

                                    {purchaseData?.status === "Draft" ? (
                                      <>
                                        <input
                                          type="text"
                                          name="qty[]"
                                          className="form-control qtyinputbox"
                                          value={row.order_qty_display !== undefined ? row.order_qty_display : row.order_qty}
                                          autoComplete="off"
                                          maxLength={6}
                                          onFocus={(e) => e.target.select()}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (!/^\d{0,6}$/.test(value)) {
                                              error = 'Max 6 digits allowed';
                                            }
                                            setFieldErrors((prev) => ({
                                              ...prev,
                                              [row.id]: { ...prev[row.id], qty: error },
                                            }));
                                            if (!error) {
                                              handleInputChange(
                                                e,
                                                row.product_id,
                                                "quantity",
                                                setItems,
                                                grnItems,
                                                row.order_qty
                                              );
                                            } else {
                                              setItems((prev) => prev.map(r => r.id === row.id ? { ...r, order_qty_display: value } : r));
                                            }
                                          }}
                                        />
                                        <FormText error={!!(fieldErrors[row.id]?.qty)}>
                                          {fieldErrors[row.id]?.qty}
                                        </FormText>
                                      </>
                                    ) : (
                                      row.order_qty
                                    )}

                                  </td>
                                  <td>
                                    {purchaseData?.status === "Draft" ? (
                                      <>
                                        <input
                                          type="text"
                                          name="cost[]"
                                          className="form-control qtyinputbox"
                                          value={row.cost_display !== undefined ? (row.cost_display && parseFloat(row.cost_display) !== 0 ? row.cost_display : '') : (row.cost && parseFloat(row.cost) !== 0 ? row.cost : '')}
                                          autoComplete="off"
                                          maxLength={10}
                                          onFocus={(e) => e.target.select()}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (!/^\d{0,8}(\.\d{0,2})?$/.test(value)) {
                                              error = 'Max 2 decimal places allowed';
                                            }
                                            setFieldErrors((prev) => ({
                                              ...prev,
                                              [row.id]: { ...prev[row.id], cost: error },
                                            }));
                                            if (!error) {
                                              handleInputChange_cprice(
                                                e,
                                                row.product_id,
                                                "cost",
                                                setItems,
                                                grnItems,
                                                row.newlyAdded,
                                                row.order_qty
                                              );
                                            } else {
                                              setItems((prev) => prev.map(r => r.id === row.id ? { ...r, cost_display: value } : r));
                                            }
                                          }}
                                        />
                                        <FormText error={!!(fieldErrors[row.id]?.cost)}>
                                          {fieldErrors[row.id]?.cost}
                                        </FormText>
                                      </>
                                    ) : (
                                      row.cost
                                    )}

                                  </td>
                                  <td>
                                    <input
                                      type="hidden"
                                      name="value[]"
                                      className="form-control qtyinputbox"
                                      value={Number(row.value ?? 0).toFixed(2)}
                                      readOnly
                                    />
                                    {Number(row.value ?? 0).toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="hidden"
                                      name="Disc[]"
                                      value={(totalCosts ?? 0).toFixed(2)}
                                    />

                                    {(totalCosts ?? 0).toFixed(2)}

                                  </td>
                                  <td>
                                    <input
                                      type="hidden"
                                      name="NetP[]"
                                      value={parseFloat(row.netp) ?? 0}
                                    />
                                    {parseFloat(row.netp) ?? 0}
                                  </td>
                                  <td>
                                    <input
                                      type="hidden"
                                      name="vat[]"
                                      value={vatAmount ?? 0}
                                    />
                                    <input
                                      type="hidden"
                                      name="vatpercentage[]"
                                      value={row.vat_percentage ?? 0}
                                    />
                                    {vatAmount ?? 0}
                                  </td>
                                  <td>
                                    <input
                                      type="hidden"
                                      name="currrentStock[]"
                                      value={row.sys_quantity ?? 0}
                                    />
                                    {row.sys_quantity ?? 0}
                                  </td>
                                  <td>
                                    {/* <input
                                      type="hidden"
                                      name="onSO[]"
                                      value="0"
                                    /> */}
                                    {/* <span>{row.on_so || 0}</span> */}



                                    <input type="hidden" name="onSO[]" value="0" />
                                    {(row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001') ? (
                                      0
                                    ) : (
                                      <a
                                        href="#"
                                        data-id={row.product_id}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          getonpo(row.product_id, row.product_id);
                                        }}
                                        data-bs-toggle="modal"
                                        data-bs-target="#ON-PO"
                                      >
                                        {row.on_so || 0}
                                      </a>
                                    )}
                                  </td>
                                  <td>
                                    <input
                                      type="hidden"
                                      name="fstk[]"
                                      value="0"
                                    />
                                    {(row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001') ? (
                                      0
                                    ) : (
                                      fstk_cal ?? 0
                                    )}
                                  </td>
                                  <td>

                                    {purchaseData?.status === "Draft" && (
                                      <a
                                        href="#"
                                        onClick={() =>
                                          removeRow(row.id, setItems)
                                        }
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="purchaseftr">
                      <div className="row">
                        <div className="col-6 col-lg-3 col-sm-3">
                          <p className="frtbx">
                            {" "}
                            Std Goods :{" "}
                            <span id="std_goods">{stdGoods.toFixed(2)}</span>
                          </p>
                        </div>
                        <div className="col-6 col-lg-3 col-sm-3">
                          <p className="frtbx">
                            {" "}
                            VAT Amount :{" "}
                            <span id="vat_amt">{vatAmt.toFixed(2)}</span>
                          </p>
                        </div>
                        <div className="col-6 col-lg-3 col-sm-3">
                          <p className="frtbx">
                            {" "}
                            Zero Goods :{" "}
                            <span id="zero_goods">{zeroGoods.toFixed(2)}</span>
                          </p>
                        </div>
                        <div className="col-6 col-lg-3 col-sm-3">
                          <p className="frtbx last">
                            {" "}
                            Gross Total :{" "}
                            <span id="grand_total">
                              {grandTotal.toFixed(2)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="purchaseftr">
                      <div className="row">
                        <div className="col-6 col-lg-3 col-sm-3">
                          <p className="frtbx">
                            {" "}
                            Net Std Goods :{" "}
                            <span id="std_goods">{netStdGoods.toFixed(2)}</span>
                          </p>
                        </div>
                        <div className="col-6 col-lg-3 col-sm-3">
                          <p className="frtbx">
                            {" "}
                            VAT Amount :{" "}
                            <span id="vat_amt">{netVatAmt.toFixed(2)}</span>
                          </p>
                        </div>
                        <div className="col-6 col-lg-3 col-sm-3">
                          <p className="frtbx">
                            {" "}
                            Zero Goods :{" "}
                            <span id="zero_goods">
                              {netZeroGoods.toFixed(2)}
                            </span>
                          </p>
                        </div>
                        <div className="col-6 col-lg-3 col-sm-3">
                          <p className="frtbx last">
                            {" "}
                            Gross Total :{" "}
                            <span id="grand_total">
                              {netGrandTotal.toFixed(2)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="purchaseform">
                      <div className="row mb-3 padd-l-13px">
                        <div className="col-6 col-lg-6 col-sm-6">
                          <div className="row mb-3">
                            <div className="col-3 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">
                                Date of Arrival
                              </label>
                            </div>

                            <div className="col-3 col-lg-3 col-sm-3">
                              <CustomDateInput
                                name="arrival_date"
                                id="arrival_date"
                                value={purchaseData?.arrival_date || ''}
                                onChange={(date) => {
                                  setPurchaseData({
                                    ...purchaseData,
                                    arrival_date: date,
                                  });
                                }}
                              />
                            </div>

                            <div className="col-3 col-lg-3 col-sm-3">
                              <label
                                htmlFor="desc"
                                className="col-form-label padd-left-50"
                              >
                                Job Ref
                              </label>
                            </div>

                            <div className="col-3 col-lg-3 col-sm-3">
                              <input
                                type="text"
                                className="form-control"
                                name="job_ref"
                                id="job_ref"
                                value={purchaseData?.job_ref || ''}
                                maxLength={100}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let error = '';
                                  if (value.length > 100) {
                                    error = 'Max 100 characters allowed';
                                  } else {
                                    error = '';
                                    setJobRefError('');
                                  }
                                  setJobRefError(error);
                                  setPurchaseData({
                                    ...purchaseData,
                                    job_ref: value,
                                  });
                                }}
                                onBlur={async (e) => {
                                  const value = e.target.value.trim();
                                  if (value && value !== '') {
                                    const jobRefCheck = await checkJobRefExists(value, id);
                                    if (jobRefCheck && jobRefCheck.exists) {
                                      Swal.fire({
                                        title: "Error!",
                                        text: `Job Reference '${value}' has already been used on PO# ${jobRefCheck.poNumber}`,
                                        icon: "error",
                                        timer: 3000,
                                        showConfirmButton: true,
                                      });
                                      e.target.value = '';
                                      setPurchaseData({
                                        ...purchaseData,
                                        job_ref: '',
                                      });
                                      setJobRefError('');
                                    } else {
                                      setJobRefError('');
                                    }
                                  } else {
                                    setJobRefError('');
                                  }
                                }}
                              />
                              <FormText error={!!jobRefError}>{jobRefError}</FormText>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-3 col-lg-3 col-sm-3">
                              <label className="col-form-label padd-left-50">
                                Delivery
                              </label>
                            </div>

                            <div className="col-3 col-lg-3 col-sm-3">
                              <input
                                type="radio"
                                name="delivery_type"
                                id="delivery_type"
                                value="delivery"
                                checked={
                                  isDelivery === "warehouse" ||
                                  isDelivery === "customer"
                                }
                                onChange={(e) =>
                                  handleDeliveryandCollectionAddress(e)
                                }
                                style={{ float: "left" }}
                              />
                            </div>

                            <div className="col-3 col-lg-3 col-sm-3">
                              <label
                                htmlFor="collection"
                                className="col-form-label padd-left-50"
                              >
                                Collection
                              </label>
                            </div>

                            <div className="col-3 col-lg-3 col-sm-3">
                              <input
                                type="radio"
                                name="delivery_type"
                                id="collection_type"
                                value="collection"
                                checked={isDelivery === "collection"}
                                onChange={(e) =>
                                  handleDeliveryandCollectionAddress(e)
                                }
                              />
                            </div>
                          </div>

                          {(isDelivery === "delivery" ||
                            isDelivery === "customer" ||
                            isDelivery === "warehouse") && (
                              <div className="row mb-3">
                                <div className="col-3 col-lg-3 col-sm-3">
                                  <label
                                    htmlFor="warehouse"
                                    className="col-form-label padd-left-50"
                                  >
                                    Warehouse Address
                                  </label>
                                </div>
                                <div className="col-3 col-lg-3 col-sm-3">
                                  <input
                                    type="radio"
                                    onChange={handleWarehouseandCustomerAddress}
                                    name="handleWarehouseandCustomerAddress"
                                    id="warehouse"
                                    checked={isDelivery === "warehouse"}
                                    value="warehouse"

                                    readOnly={purchaseData?.status !== "Draft"}
                                  />
                                </div>

                                <div className="col-3 col-lg-3 col-sm-3">
                                  <label
                                    htmlFor="customer"
                                    className="col-form-label padd-left-50"
                                  >
                                    Customer Address
                                  </label>
                                </div>
                                <div className="col-3 col-lg-3 col-sm-3">
                                  <input
                                    type="radio"
                                    onChange={handleWarehouseandCustomerAddress}
                                    name="handleWarehouseandCustomerAddress"
                                    id="customer"
                                    checked={isDelivery === "customer"}
                                    value="customer"

                                    readOnly={purchaseData?.status !== "Draft"}
                                  />
                                </div>
                              </div>
                            )}

                          <div className="row mb-3">
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">
                                Notes
                              </label>
                            </div>
                            <div className="col-6 col-lg-9 col-sm-9">
                              <textarea
                                className="form-control"
                                name="notes"
                                id="notes"
                                style={{ height: "200px" }}
                                value={purchaseData?.notes || ''}
                                maxLength={500}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let error = '';
                                  if (value.length > 500) {
                                    error = 'Max 500 characters allowed';
                                  }
                                  setNotesError(error);
                                  setPurchaseData({
                                    ...purchaseData,
                                    notes: value,
                                  });
                                }}
                                readOnly={purchaseData?.status !== "Draft"}
                              />
                              <FormText error={!!notesError}>{notesError}</FormText>
                            </div>
                          </div>
                        </div>

                        {(isDelivery === "delivery" ||
                          isDelivery === "warehouse" ||
                          isDelivery === "customer") && (
                            <div className="col-6 col-lg-6 col-sm-6">
                              {(isDelivery === "warehouse" ||
                                isDelivery === "delivery") && (
                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label
                                        htmlFor="desc"
                                        className="col-form-label"
                                      >
                                        Delivery Address{" "}
                                        <span className="red">*</span>
                                      </label>
                                    </div>

                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <select
                                        name="delivery_id"
                                        id="delivery_id"
                                        className="form-select orgselect"
                                        value={preDeliverData}
                                        onChange={(event) => {
                                          changeWarehouseAddress(
                                            event,
                                            setDeliveryAddress,
                                            warehouseDeliveryAddress
                                          );
                                          setPreDeliverData(event.target.value);
                                        }}
                                      >
                                        <option value="">Select Address</option>
                                        {warehouseDeliveryAddress.map(
                                          (item, index) => (
                                            <option key={index} value={item.id}>
                                              {item.name}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </div>
                                  </div>
                                )}

                              {isDelivery === "customer" && (
                                <>
                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label
                                        htmlFor="desc"
                                        className="col-form-label"
                                      >
                                        Customer Address{" "}
                                        <span className="red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <select
                                        name="delivery_id"
                                        id="delivery_id"
                                        className="form-select orgselect"
                                        value={precustomerDeliverData}
                                        onChange={(event) => {
                                          changeCustomerAddress(
                                            event,
                                            setCustomerAddress,
                                            customerDeliveryAddress
                                          );
                                          setPreDeliverData(event.target.value);
                                        }}
                                      >
                                        <option value="">Select Address</option>
                                        {customerDeliveryAddress.map(
                                          (item, index) => (
                                            <option key={index} value={item?.address_line1}>
                                              {item?.address_line1}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </div>
                                  </div>

                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label
                                        htmlFor="addressLine1"
                                        className="col-form-label"
                                      >
                                        Address Line 1
                                      </label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="addressLine1"
                                        id="addressLine1"
                                        value={customerAddress?.address_line1}
                                        maxLength={255}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          let error = '';
                                          if (value.length > 255) {
                                            error = 'Max 255 characters allowed';
                                          }
                                          setAddressErrors(prev => ({ ...prev, customer_address1: error }));
                                          setCustomerAddress({
                                            ...customerAddress,
                                            address_line1: value,
                                          });
                                        }}
                                        readOnly={purchaseData?.status !== "Draft"}
                                      />
                                      <FormText error={!!addressErrors.customer_address1}>{addressErrors.customer_address1}</FormText>
                                    </div>
                                  </div>

                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label
                                        htmlFor="addressLine2"
                                        className="col-form-label"
                                      >
                                        Address Line 2
                                      </label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="addressLine2"
                                        id="addressLine2"
                                        value={customerAddress.address_line2}
                                        maxLength={255}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          let error = '';
                                          if (value.length > 255) {
                                            error = 'Max 255 characters allowed';
                                          }
                                          setAddressErrors(prev => ({ ...prev, customer_address2: error }));
                                          setCustomerAddress({
                                            ...customerAddress,
                                            address_line2: value,
                                          });
                                        }}
                                        readOnly={purchaseData?.status !== "Draft"}
                                      />
                                      <FormText error={!!addressErrors.customer_address2}>{addressErrors.customer_address2}</FormText>
                                    </div>
                                  </div>

                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label
                                        htmlFor="city"
                                        className="col-form-label"
                                      >
                                        City
                                      </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="city"
                                        id="city"
                                        value={customerAddress?.city}
                                        maxLength={50}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          let error = '';
                                          if (value.length > 50) {
                                            error = 'Max 50 characters allowed';
                                          }
                                          setAddressErrors(prev => ({ ...prev, customer_city: error }));
                                          setCustomerAddress({
                                            ...customerAddress,
                                            city: value,
                                          });
                                        }}
                                        readOnly={purchaseData?.status !== "Draft"}
                                      />
                                      <FormText error={!!addressErrors.customer_city}>{addressErrors.customer_city}</FormText>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label
                                        htmlFor="state"
                                        className="col-form-label padd-left-50"
                                      >
                                        County
                                      </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="state"
                                        id="state"
                                        value={customerAddress.state}
                                        maxLength={50}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          let error = '';
                                          if (value.length > 50) {
                                            error = 'Max 50 characters allowed';
                                          }
                                          setAddressErrors(prev => ({ ...prev, customer_state: error }));
                                          setCustomerAddress({
                                            ...customerAddress,
                                            state: value,
                                          });
                                        }}
                                        readOnly={purchaseData?.status !== "Draft"}
                                      />
                                      <FormText error={!!addressErrors.customer_state}>{addressErrors.customer_state}</FormText>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label
                                        htmlFor="country"
                                        className="col-form-label"
                                      >
                                        Country
                                      </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="country"
                                        id="country"
                                        value={customerAddress.country}
                                        maxLength={50}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          let error = '';
                                          if (value.length > 50) {
                                            error = 'Max 50 characters allowed';
                                          }
                                          setAddressErrors(prev => ({ ...prev, customer_country: error }));
                                          setCustomerAddress({
                                            ...customerAddress,
                                            country: value,
                                          });
                                        }}
                                        readOnly={purchaseData?.status !== "Draft"}
                                      />
                                      <FormText error={!!addressErrors.customer_country}>{addressErrors.customer_country}</FormText>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label
                                        htmlFor="postCode"
                                        className="col-form-label padd-left-50"
                                      >
                                        Post Code
                                      </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="postCode"
                                        id="postCode"
                                        value={customerAddress.postcode}
                                        maxLength={50}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          let error = '';
                                          if (value.length > 50) {
                                            error = 'Max 50 characters allowed';
                                          }
                                          setAddressErrors(prev => ({ ...prev, customer_postcode: error }));
                                          setCustomerAddress({
                                            ...customerAddress,
                                            postcode: value,
                                          });
                                        }}
                                        readOnly={purchaseData?.status !== "Draft"}
                                      />
                                      <FormText error={!!addressErrors.customer_postcode}>{addressErrors.customer_postcode}</FormText>
                                    </div>
                                  </div>
                                </>
                              )}

                              {(isDelivery === "warehouse" ||
                                isDelivery === "delivery") && (
                                  <>
                                    <div className="row mb-3">
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <label
                                          htmlFor="name"
                                          className="col-form-label"
                                        >
                                          Warehouse Name
                                        </label>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="name"
                                          id="warehouse_name"
                                          value={deliveryAddress.name}
                                          maxLength={50}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (value.length > 50) {
                                              error = 'Max 50 characters allowed';
                                            }
                                            setAddressErrors(prev => ({ ...prev, delivery_name: error }));
                                            setDeliveryAddress({ ...deliveryAddress, name: value });
                                          }}
                                          readOnly={purchaseData?.status !== "Draft"}
                                        />
                                        <FormText error={!!addressErrors.delivery_name}>{addressErrors.delivery_name}</FormText>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <label
                                          htmlFor="code"
                                          className="col-form-label padd-left-50"
                                        >
                                          Code
                                        </label>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="warehouse_code"
                                          id="wcode"
                                          maxLength={10}
                                          value={deliveryAddress.code}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (value.length > 50) {
                                              error = 'Max 50 characters allowed';
                                            }
                                            setAddressErrors(prev => ({ ...prev, delivery_code: error }));
                                            setDeliveryAddress({ ...deliveryAddress, code: value });
                                          }}
                                          readOnly={purchaseData?.status !== "Draft"}
                                        />
                                        <FormText error={!!addressErrors.delivery_code}>{addressErrors.delivery_code}</FormText>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <label htmlFor="addressLine1" className="col-form-label">
                                          Address Line 1
                                        </label>
                                      </div>
                                      <div className="col-6 col-lg-9 col-sm-9">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="addressLine1"
                                          id="waddr1"
                                          value={deliveryAddress.address_line1}
                                          maxLength={255} // ADD THIS
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (value.length > 255) {
                                              error = 'Max 255 characters allowed';
                                            }
                                            setAddressErrors(prev => ({ ...prev, delivery_address1: error }));
                                            setDeliveryAddress({
                                              ...deliveryAddress,
                                              address_line1: value,
                                            });
                                          }}
                                          readOnly={purchaseData?.status !== "Draft"}
                                        />
                                        <FormText error={!!addressErrors.delivery_address1}>{addressErrors.delivery_address1}</FormText>
                                      </div>
                                    </div>

                                    <div className="row mb-3">
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <label htmlFor="desc" className="col-form-label">
                                          Address Line 2
                                        </label>
                                      </div>
                                      <div className="col-6 col-lg-9 col-sm-9">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="addressLine2"
                                          id="waddr2"
                                          value={deliveryAddress?.address_line2}
                                          maxLength={255} // ADD THIS
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (value.length > 255) {
                                              error = 'Max 255 characters allowed';
                                            }
                                            setAddressErrors(prev => ({ ...prev, delivery_address2: error }));
                                            setDeliveryAddress({
                                              ...deliveryAddress,
                                              address_line2: value,
                                            });
                                          }}
                                          readOnly={purchaseData?.status !== "Draft"}
                                        />
                                        <FormText error={!!addressErrors.delivery_address2}>{addressErrors.delivery_address2}</FormText>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <label
                                          htmlFor="desc"
                                          className="col-form-label"
                                        >
                                          City
                                        </label>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="city"
                                          id="wcity"
                                          value={deliveryAddress.city}
                                          maxLength={50}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (value.length > 50) {
                                              error = 'Max 50 characters allowed';
                                            }
                                            setAddressErrors(prev => ({ ...prev, delivery_city: error }));
                                            setDeliveryAddress({ ...deliveryAddress, city: value });
                                          }}
                                          readOnly={purchaseData?.status !== "Draft"}
                                        />
                                        <FormText error={!!addressErrors.delivery_city}>{addressErrors.delivery_city}</FormText>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <label
                                          htmlFor="desc"
                                          className="col-form-label padd-left-50"
                                        >
                                          County
                                        </label>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="state"
                                          id="wstate"
                                          value={deliveryAddress.state}
                                          maxLength={50}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (value.length > 50) {
                                              error = 'Max 50 characters allowed';
                                            }
                                            setAddressErrors(prev => ({ ...prev, delivery_state: error }));
                                            setDeliveryAddress({ ...deliveryAddress, state: value });
                                          }}
                                          readOnly={purchaseData?.status !== "Draft"}
                                        />
                                        <FormText error={!!addressErrors.delivery_state}>{addressErrors.delivery_state}</FormText>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <label
                                          htmlFor="desc"
                                          className="col-form-label"
                                        >
                                          Country
                                        </label>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="country"
                                          id="wcountry"
                                          value={deliveryAddress.country}
                                          maxLength={50}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (value.length > 50) {
                                              error = 'Max 50 characters allowed';
                                            }
                                            setAddressErrors(prev => ({ ...prev, delivery_country: error }));
                                            setDeliveryAddress({ ...deliveryAddress, country: value });
                                          }}
                                          readOnly={purchaseData?.status !== "Draft"}
                                        />
                                        <FormText error={!!addressErrors.delivery_country}>{addressErrors.delivery_country}</FormText>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <label
                                          htmlFor="desc"
                                          className="col-form-label padd-left-50"
                                        >
                                          Post Code
                                        </label>
                                      </div>
                                      <div className="col-6 col-lg-3 col-sm-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="postCode"
                                          id="wpostCode"
                                          value={deliveryAddress.postcode}
                                          maxLength={50}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            let error = '';
                                            if (value.length > 50) {
                                              error = 'Max 50 characters allowed';
                                            }
                                            setAddressErrors(prev => ({ ...prev, delivery_postcode: error }));
                                            setDeliveryAddress({ ...deliveryAddress, postcode: value });
                                          }}
                                          readOnly={purchaseData?.status !== "Draft"}
                                        />
                                        <FormText error={!!addressErrors.delivery_postcode}>{addressErrors.delivery_postcode}</FormText>
                                      </div>
                                    </div>
                                  </>
                                )}
                            </div>
                          )}
                        {isDelivery === "collection" && (
                          <div className="col-6 col-lg-6 col-sm-6">
                            <div className="row mb-3">
                              <div className="col-6 col-lg-3 col-sm-3">
                                <label
                                  htmlFor="desc"
                                  className="col-form-label padd-left-50"
                                >
                                  Collection Address
                                </label>
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3"></div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-6 col-lg-3 col-sm-3">
                                <label
                                  htmlFor="desc"
                                  className="col-form-label"
                                >
                                  Address Line 1
                                </label>
                              </div>
                              <div className="col-6 col-lg-9 col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="addressLine1"
                                  id="caddressLine"
                                  value={collectionAddress?.address_line1}
                                  maxLength={255}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    let error = '';
                                    if (value.length > 255) {
                                      error = 'Max 255 characters allowed';
                                    }
                                    setAddressErrors(prev => ({ ...prev, collection_address1: error }));
                                    setCollectionAddress({
                                      ...collectionAddress,
                                      address_line1: value,
                                    });
                                  }}
                                />
                                <FormText error={!!addressErrors.collection_address1}>{addressErrors.collection_address1}</FormText>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-6 col-lg-3 col-sm-3">
                                <label
                                  htmlFor="desc"
                                  className="col-form-label"
                                >
                                  Address Line 2
                                </label>
                              </div>
                              <div className="col-6 col-lg-9 col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="addressLine2"
                                  id="caddressLine2"
                                  value={collectionAddress?.address_line2}
                                  maxLength={255}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    let error = '';
                                    if (value.length > 255) {
                                      error = 'Max 255 characters allowed';
                                    }
                                    setAddressErrors(prev => ({ ...prev, collection_address2: error }));
                                    setCollectionAddress({
                                      ...collectionAddress,
                                      address_line2: value,
                                    });
                                  }}
                                />
                                <FormText error={!!addressErrors.collection_address2}>{addressErrors.collection_address2}</FormText>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-6 col-lg-3 col-sm-3">
                                <label
                                  htmlFor="desc"
                                  className="col-form-label"
                                >
                                  City
                                </label>
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="city"
                                  id="ccity"
                                  value={collectionAddress?.city}
                                  maxLength={50}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    let error = '';
                                    if (value.length > 50) {
                                      error = 'Max 50 characters allowed';
                                    }
                                    setAddressErrors(prev => ({ ...prev, collection_city: error }));
                                    setCollectionAddress({ ...collectionAddress, city: value });
                                  }}
                                />
                                <FormText error={!!addressErrors.collection_city}>{addressErrors.collection_city}</FormText>
                              </div>

                              <div className="col-6 col-lg-3 col-sm-3">
                                <label
                                  htmlFor="desc"
                                  className="col-form-label padd-left-50"
                                >
                                  County
                                </label>
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="state"
                                  id="cstate"
                                  value={collectionAddress?.state}
                                  maxLength={50}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    let error = '';
                                    if (value.length > 50) {
                                      error = 'Max 50 characters allowed';
                                    }
                                    setAddressErrors(prev => ({ ...prev, collection_state: error }));
                                    setCollectionAddress({ ...collectionAddress, state: value });
                                  }}
                                />
                                <FormText error={!!addressErrors.collection_state}>{addressErrors.collection_state}</FormText>
                              </div>
                            </div>

                            <div className="row mb-3">
                              <div className="col-6 col-lg-3 col-sm-3">
                                <label
                                  htmlFor="desc"
                                  className="col-form-label"
                                >
                                  Country
                                </label>
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="country"
                                  id="ccountry"
                                  value={collectionAddress?.country}
                                  maxLength={50}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    let error = '';
                                    if (value.length > 50) {
                                      error = 'Max 50 characters allowed';
                                    }
                                    setAddressErrors(prev => ({ ...prev, collection_country: error }));
                                    setCollectionAddress({ ...collectionAddress, country: value });
                                  }}
                                />
                                <FormText error={!!addressErrors.collection_country}>{addressErrors.collection_country}</FormText>
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3">
                                <label
                                  htmlFor="desc"
                                  className="col-form-label padd-left-50"
                                >
                                  Post Code
                                </label>
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="postCode"
                                  id="cpostCode"
                                  value={collectionAddress?.postcode}
                                  maxLength={50}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    let error = '';
                                    if (value.length > 50) {
                                      error = 'Max 50 characters allowed';
                                    }
                                    setAddressErrors(prev => ({ ...prev, collection_postcode: error }));
                                    setCollectionAddress({ ...collectionAddress, postcode: value });
                                  }}
                                />
                                <FormText error={!!addressErrors.collection_postcode}>{addressErrors.collection_postcode}</FormText>
                              </div>
                            </div>
                          </div>
                        )}

                        <input
                          type="hidden"
                          name="std_goods"
                          value={stdGoods}
                        />
                        <input
                          type="hidden"
                          name="zero_goods"
                          value={zeroGoods}
                        />
                        <input type="hidden" name="vat_amount" value={vatAmt} />
                        <input
                          type="hidden"
                          name="grand_total"
                          value={grandTotal}
                        />
                        <input
                          type="hidden"
                          name="net_std_goods"
                          value={netStdGoods}
                        />
                        <input
                          type="hidden"
                          name="net_zero_goods"
                          value={netZeroGoods}
                        />
                        <input
                          type="hidden"
                          name="net_vat_amount"
                          value={netVatAmt}
                        />
                        <input
                          type="hidden"
                          name="net_grand_total"
                          value={netGrandTotal}
                        />
                        <div className="col-6 col-lg-12 col-sm-12">
                          <hr />
                        </div>

                        <div className="col-6 col-lg-12 col-sm-12">
                          {purchaseData?.status === "Draft" && (
                            <Link
                              to="#"
                              className="popup-innerbtn-common right"
                              onClick={submitPurchaseOrderForm}
                              id="submitPurchaseOrderForm"
                            >
                              Update Purchase Order
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <Footer />
    </div>
  );
};

export default EditNewPurchaseOrder;
